import AccountMenu from '../common/AccountMenu';
import React, { useEffect, useState } from 'react';
import { logoutApi } from '../../services/auth/authService';
import { useNavigate } from 'react-router-dom';
import { getProfile } from '../../services/user/profile.services';
import { getNotifications } from '../../services/user/notification.services';
import { useNotification } from '../../context/NotificationContext';
import { NOTIFICATION_REFRESH_EVENT, revokeCurrentWebPushToken } from '../../services/webPush/firebaseWebPush';
import { clearAllLocalLogoutData } from '../../utils/logoutCleanup';

function Header() {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const { unreadCount, syncNotifications } = useNotification();

  const fetchNotifications = async () => {
    try {
      const response = await getNotifications({ page: 1, limit: 50 });
      if (response && response.notifications) {
        syncNotifications(response.notifications, { showPopups: true });
      }
    } catch (error) {
      // non-blocking
    }
  };


  useEffect(() => {
    fetchProfile();
    fetchNotifications(); // Add this line to fetch notifications on component mount
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchNotifications();
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleNotificationRefresh = () => {
      fetchNotifications();
    };

    window.addEventListener(NOTIFICATION_REFRESH_EVENT, handleNotificationRefresh);
    return () => window.removeEventListener(NOTIFICATION_REFRESH_EVENT, handleNotificationRefresh);
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await getProfile();
      setProfileData(response.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };






  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    try {
      await revokeCurrentWebPushToken();
      // Optionally call logout API
      await logoutApi();

      // Clear all local/browser data for the signed-in user
      await clearAllLocalLogoutData();

      // Redirect to login page
      navigate('/auth/login');
    } catch (error) {
      console.error("Logout error:", error);
      await clearAllLocalLogoutData();
      navigate('/auth/login');
    }
  };


  // Toggle dropdown for mobile view


  return <AccountMenu workspace="user" profile={profileData} unreadCount={unreadCount} onLogout={handleLogout} isLoggingOut={isLoggingOut} />;
}

export default Header;
